"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunStyleReferenceDestination = void 0;
var tslib_1 = require("tslib");
var run_style_reference_base_destination_1 = require("../style/run-style-reference-base-destination");
var RunStyleReferenceDestination = (function (_super) {
    tslib_1.__extends(RunStyleReferenceDestination, _super);
    function RunStyleReferenceDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RunStyleReferenceDestination.prototype.assignCharacterStyle = function (style) {
        this.data.subDocumentInfo.characterImporter.style = style;
    };
    return RunStyleReferenceDestination;
}(run_style_reference_base_destination_1.RunStyleReferenceBaseDestination));
exports.RunStyleReferenceDestination = RunStyleReferenceDestination;
